import useClientContext from "../../contexts/useClientContext";
import useClientPageTitle from "../../contexts/useClientPageTitle";
import PortfolioWidget from "../widgets/PortfolioWidget";
import WidgetsPageContainer from "../widgets/WidgetsPageContainer";

const PortfolioPage = () => {
  useClientPageTitle("Portfolio");

  const { portfolioWidget } = useClientContext();

  return (
    <WidgetsPageContainer>
      {portfolioWidget && <PortfolioWidget widgetSettings={portfolioWidget} />}
    </WidgetsPageContainer>
  );
};

export default PortfolioPage;
